import { createStyles, makeStyles } from '@material-ui/styles';
import CrossPattern from 'assets/avatar/categories/cross-pattern.png';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      backgroundColor: palette.background.box,
      padding: '10px',
      borderRadius: palette.borderRadius.large,
      boxShadow: palette.shadows.boxShadow
    },
    container: {
      marginTop: '10px'
    },
    avatars: {
      display: 'flex',
      gap: '18px',
      justifyContent: 'center',
      margin: '10px 0 20px 0',
      flexWrap: 'wrap'
    },
    noavatars: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      gap: '10px',
      padding: '10px',
      textAlign: 'center',
      backgroundColor: palette.common.red,
      backgroundImage: `url(${CrossPattern})`,
      color: palette.common.white,
      textShadow: palette.shadows.textShadow,
      borderRadius: palette.borderRadius.default,
      '&>h3': {
        fontSize: '2rem'
      }
    },
    relativeAvatar: {
      position: 'relative'
    },
    image: {
      width: '80px',
      border: '2px solid white',
      borderRadius: palette.borderRadius.default
    },
    badge: {
      position: 'absolute',
      bottom: '7px',
      right: '2px'
    },
    text: {
      fontWeight: 400,
      fontSize: '16px',
      color: palette.text.lighter,
      margin: '5px 0px 10px 0px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
